import { render, staticRenderFns } from "./Sbpayok.vue?vue&type=template&id=1f2b6294&"
import script from "./Sbpayok.vue?vue&type=script&lang=js&"
export * from "./Sbpayok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports